var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmobPullout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-power-off-icon lucide-power-off",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.64A9 9 0 0 1 20.77 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16 6.16a9 9 0 1 0 12.68 12.68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2 2 20 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmobPullout);
export default __webpack_public_path__ + "static/media/immob_pullout.3e10396ab161a530f86b8f1ffaa6dd25.svg";
export { ForwardRef as ReactComponent };